import { render, staticRenderFns } from "./BulkCSVUploadForm.vue?vue&type=template&id=b95a570a"
import script from "./BulkCSVUploadForm.vue?vue&type=script&lang=js"
export * from "./BulkCSVUploadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports